import { Close, Menu, ExpandLess, ExpandMore } from '@material-ui/icons';
import React, { useContext, useState } from 'react';
import { IMenuItem } from '../..';
import { useLocation } from 'react-router-dom';
import { Context } from 'src/context';
import { v4 as uuidv4 } from 'uuid';
import { useHasUserPermission } from 'src/context/hooks/useHasUserPermission';
import useBranchTypeModel from 'src/context/hooks/useBranchType';
// import { useHasEmailPermission } from 'src/context/hooks/useHasEmailPermission';
import { ColorsMenu } from './style';

interface Props {
  items: Array<IMenuItem[]>;
  isOpen: boolean;
  setOpen(state: boolean): void;
}

const SidebarItem = ({
  item,
  isOpen,
  isAdmin,
  isOpenSubmenu,
  setIsOpenSubmenu,
  currentRouteSelected,
}: {
  item: IMenuItem;
  isOpen: boolean;
  isAdmin: boolean | undefined;
  isOpenSubmenu: string | null;
  setIsOpenSubmenu: (name: string | null) => void;
  currentRouteSelected: string;
}) => {
  const Icon = item.icon;

  const isSubmenuActive = item.subActions && item.subActions.some((sub: any) => sub.page === currentRouteSelected);
  const isRoutesChildToActive = item?.routesChildToActive?.some((route: string) => currentRouteSelected.includes(route)) || item.subActions?.some((sub: any) => sub.routesChildToActive?.some((route: string) => currentRouteSelected.includes(route)));
  const isActive = currentRouteSelected === item.page || isSubmenuActive || isRoutesChildToActive;
  const colors = isAdmin ? ColorsMenu.admin : ColorsMenu.user

  if (item.subActions && item.subActions.length > 0) {
    return (
      <div className="w-full" key={item.name}>
        <div
          onClick={() => setIsOpenSubmenu(isOpenSubmenu === item.name ? null : item.name)}
          className={`${isActive ? `bg-[${colors.background}]` : 'hover:bg-[#F5F5F5]'} flex items-center justify-between w-full h-14 px-4 cursor-pointer`}
        >
          <div className="flex gap-4 items-center">
            <Icon style={{ color: isActive ? colors.icon : '#00000099' }} />
            <p className={`font-medium overflow-hidden ${isActive ? `text-[${colors.text}]` : 'text-greySada'}`}>{isOpen && item.name}</p>
          </div>
          {isOpen && (isOpenSubmenu === item.name ? <ExpandLess /> : <ExpandMore />)}
        </div>
        {isOpen && isOpenSubmenu === item.name && (
          <>
            {item.subActions.map((sub: any) => {
              const isSubActive = currentRouteSelected === sub.page || sub.routesChildToActive?.some((route: string) => currentRouteSelected.includes(route));
              return (
                <div className={`${isSubActive && 'bg-[#F5FAFD]'}`} key={sub.name}>
                  <div className="ml-8 border-l-2 border-[#0F5977]">
                    <div
                      key={sub.name}
                      onClick={sub.onClick}
                      className={`flex items-center h-12 px-4 cursor-pointer ${isSubActive ? 'bg-[#F5FAFD] border-[#0F5977] border-l-[3px]' : 'hover:bg-[#F5F5F5]'}`}
                    >
                      <span className={`text-md ${isSubActive ? 'text-[#0F5977] font-semibold' : 'text-greySada'}`}>{sub.name}</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </>
        )}
      </div>
    );
  }

  return (
    <div
      key={item.name}
      onClick={item.onClick}
      className={`${isActive ? `bg-[${colors.background}]` : 'hover:bg-[#F5F5F5]'} flex gap-4 items-center justify-start w-full h-14 px-4 cursor-pointer`}
    >
      <Icon style={{ color: isActive ? colors.icon : '#00000099' }} />
      <p className={`font-medium overflow-hidden min-w-[210px] ${isActive ? `text-[${colors.text}]` : 'text-greySada'}`}>{isOpen && item.name}</p>
    </div>
  );
};

export const Sidebar: React.FC<Props> = ({ items, isOpen, setOpen }) => {
  const { userAuth } = useContext(Context);
  const { hasUserPermissionByPermission } = useHasUserPermission();
  const { isBranchIgarape } = useBranchTypeModel();
  // const { hasEmailPermission } = useHasEmailPermission(); Hook para determinar se o usuario tem permissao para acessar solicitacoes de forma estatica
  const location = useLocation();
  const [isOpenSubmenu, setIsOpenSubmenu] = useState<string | null>(null);

  const showIgarapeMenus = (item: IMenuItem): boolean => {
    if (!isBranchIgarape())
      return true
    return true
  }

  const hasPermission = (item: IMenuItem): boolean => {
    if (!isAdmin) return true
    return hasUserPermissionByPermission(item.permission)
  }

  if (!userAuth) return null;

  const isAdmin = userAuth.admin;

  const sidebarItems = items[0].filter((item) => item.admin === isAdmin && hasPermission(item) && showIgarapeMenus(item) && !item.hideMenu);

  return (
    <aside
      className={`fixed mt-16 h-screen z-40 bg-white duration-200 ${isOpen ? 'w-64' : 'w-16'} border-r-[1px] border-b-[##DBDDE2] max-h-fill-available`}
    >
      <div
        onClick={() => setOpen(!isOpen)}
        className="flex w-full h-14 items-center justify-between cursor-pointer p-4 border-b-[1px] border-b-[##DBDDE2]"
      >
        {isOpen ? (
          <>
            <h2 className="text-xl font-medium">Menu</h2>
            <Close className="text-gray-500" />
          </>
        ) : (
          <Menu className="text-greySada" style={{ fontSize: 28 }} />
        )}
      </div>
      {sidebarItems.map((item) => (
        <SidebarItem
          item={item}
          isOpen={isOpen}
          key={uuidv4()}
          isAdmin={item.admin}
          isOpenSubmenu={isOpenSubmenu}
          setIsOpenSubmenu={setIsOpenSubmenu}
          currentRouteSelected={location.pathname}
        />
      ))}
    </aside>
  );
};
